import React from 'react';
import { useSelector } from 'react-redux';

const Profile = () => {
  const { myPage } = useSelector((state) => state.navigation);
  return (
    <div className="top-link">
      {myPage && myPage.text && (
        <a href={myPage.href} title={myPage.text}>
          {myPage.text}
        </a>
      )}
    </div>
  );
};

export default Profile;
